


































import Vue from 'vue';
import { LOAD_STATE } from '@/store/shared';
import CampaignGlance from '@/components/Dunning/Analytics/DunningCampaignGlance.vue';
import DunningTimeline from '@/components/Dunning/Analytics/DunningTimeline.vue';
import DunningOverall from '@/components/Dunning/Analytics/DunningOverall.vue';
import DunningBreakdown from '@/components/Dunning/Analytics/DunningBreakdown.vue';
import DunningEmailRates from '@/components/Dunning/Analytics/DunningEmailRates.vue';
import DunningRecovered from '@/components/Dunning/Analytics/DunningRecovered.vue';
import DunningActivity from '@/components/Dunning/Analytics/DunningActivity.vue';
import * as mutations from '@/store/mutation-types';
import * as actions from '@/store/action-types';
import { mapGetters } from 'vuex';
import { EMAIL } from '@/helpers/stats-utils';

export default Vue.extend({
  name: 'DunningAnalytics',
  components: {
    CampaignGlance,
    DunningBreakdown,
    DunningEmailRates,
    DunningOverall,
    DunningRecovered,
    DunningTimeline,
    DunningActivity,
  },
  data() {
    return {
      LOAD_STATE,
    };
  },
});
